import React, { useEffect, useState } from 'react';
import {  useLocation } from 'react-router-dom';
import { ADMIN_ROLE, EDITOR_ROLE, SUBMITTER_ROLE, SUBMITTED_FOR_REVIEW, PUBLISHED } from '../../ModulePage/exportfiles';
import './RenderButton.scss';

const RenderButton = ({isSaving, isSubmitting, saveAction, submitAction, unsubmitAction, readOnly}) => {

  const location = useLocation();
  //org role is pulled from the state 
  const {status, org_rol_s } = location.state;
  //These states are used to activate the dot animation
  const [saveProgress, setSaveProgress] = useState(isSaving);
  const [submitProgress, setSubmitProgress] = useState(isSubmitting);
  
  //Adds a 1 second delay to show dots animation to prevent users from clicking the save or submit button while in progress
  useEffect(async () => {
    if (saveProgress) {
      await new Promise(resolve => setTimeout(resolve, 500));
      setSaveProgress(false);
    }
  }, [setSaveProgress, saveProgress]);

  useEffect(async () => {
    if (submitProgress) {
      await new Promise(resolve => setTimeout(resolve, 500));
      setSubmitProgress(false);
    }
  }, [setSubmitProgress, submitProgress]);

  //This function is based of the function found in ModulePage.js
  //Determines submit status based on Role number (found in state) and readOnly state
  const RenderSubmitButton = ({ action, unsubmitAction, roleNumber, status }) => {
    switch (roleNumber) {
      case ADMIN_ROLE:
        return (<>
            {/* If an Admin then submit/unsubmit is available*/}
            {(status.toUpperCase() === SUBMITTED_FOR_REVIEW || status.toUpperCase() === PUBLISHED)
            ? <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); unsubmitAction(); }} id='btn_edit_unsubmit' style={{ marginLeft: '10px' }} data-testid='submitBtn'  >Unsubmit</button>
            : <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); action(); }} id='btn_edit_submit' style={{ marginLeft: '10px' }} data-testid='submitBtn' >Submit</button>
            }
        </>
        );
      case SUBMITTER_ROLE:
        return (
          <>
            {/* If a Submitter then submit is available only if its not read-only*/}
            <button type='button' className={`cb-btn cb-btn-primary`} onClick={() => { setSubmitProgress(!submitProgress); action();}} disabled={readOnly} id='btn_edit_submit' style={{marginLeft: '10px'}} data-testid='submitBtn'>Submit for Review</button>
          </>
        );
      case EDITOR_ROLE:
        return (<></>);
      default:
        return (<></>);
    }
  };
  //Pulse dots button animation
  const PulseDots = (style) => {
    return (
      <button className={`cb-btn cb-btn-${style} cb-btn-pulse`} type='button'>
        Primary
        <div className='cb-btn-pulse-dots'>
          <div className='cb-btn-dots' />
        </div>
      </button>
    );
  };
  
  return (
    <span className='buttonflex'>
      <span>
    {!saveProgress ? (
      <button type='button' className={`cb-btn cb-btn-secondary`}
        disabled={readOnly}
        onClick={ ()=>{ setSaveProgress(!saveProgress); saveAction();}}
        style={{display: `${readOnly ? 'none' : 'inline-flex'}`}}
        id='btn_edit_save'
        data-testid='saveBtn'
      >
        Save
        </button>) :
      (
        <PulseDots style={'secondary'}/>
      )}
      </span>
      <span>
        {!submitProgress 
          ? (<RenderSubmitButton action={submitAction} unsubmitAction={unsubmitAction} roleNumber={org_rol_s} readOnly={readOnly} status={status}/>)
          : (<PulseDots style={'primary'} />)}
      </span>
    </span>
);};
export default RenderButton;